import { integration, view, hooks } from '@yola/ws-sdk';
import { saveSiteWithEffect } from 'src/js/modules/saving/helpers/save-site';
import store from 'src/js/store';

const redirectToStore = () => {
  const state = store.getState();
  const settings = integration.selectors.getSettings(state);
  const focusedElement = view.selectors.getFocusedElement(state);

  const redirectWithSave = () => {
    saveSiteWithEffect(() => {
      if (settings.onlinestore) {
        // Timeout to ensure the SITE_ELEMENT_CLICKED event is sent successfully before redirecting
        setTimeout(() => {
          settings.onlinestore.redirect();
        }, 500);
      }
    });
  };

  if (focusedElement) {
    hooks.operations.subscribe(
      hooks.availableHooks.ON_AFTER_BLUR_FOCUSED_ELEMENT,
      () => {
        redirectWithSave();
      },
      {
        once: true,
      }
    );
  } else {
    redirectWithSave();
  }
};

export default redirectToStore;
